module.exports = __webpack_public_path__ + "static/media/book.ad256325.svg";